export default __webpack_public_path__ + "static/media/LinkedIn-icon.033dd86b.svg";